import { type DragEvent } from 'react';
import { PdfViewer } from '../PdfViewer';
import { PANEL_CARD, PanelTitle } from '../PanelCard';
import { usePartBoxes } from '../partsRun';
import { NoticeInfoTable } from '../NoticeInfoTable';

type DropZoneProps = {
  onDragOver: (e: DragEvent) => void;
  onDragLeave: () => void;
  onDrop: (e: DragEvent) => void;
};

// The manual itself — its pages, and the product fields read off them underneath: Phase 1's
// manual (see CategoryTable). It was a phase of its own. Built by NoticeViewer, which owns the file,
// the page count and the drag state, and handed to the phase through PhaseCtx.manual;
// extracted to keep that file under the size limit. This only draws and reports gestures.
//
// NO UPLOAD BUTTON. There used to be one directly above the PDF, and it did not
// replace the open manual as its position suggested — it ran the same onPick as
// everywhere else, which ADDS a document and navigates to it. That is the library's
// "New manual" button, one screen back, reached from a phase that is about the
// manual already open. One door, on the screen that lists them.
export function UploadPanel({
  docId,
  file,
  onNumPages,
  dropZoneProps,
  dragging,
  t,
}: {
  docId: string;
  file: Blob;
  // How many pages the PDF turned out to have — reported by the viewer below and held
  // by the reader.
  onNumPages: (n: number) => void;
  dropZoneProps: DropZoneProps;
  dragging: boolean;
  t: (k: string) => string;
}) {
  // Once Phase 2 has extracted the supplied parts, draw their boxes over the
  // manual here too — this full-document reader is the most visible PDF.
  const partBoxes = usePartBoxes(docId);
  return (
    <div
      {...dropZoneProps}
      className={`${PANEL_CARD} overflow-hidden ${
        dragging ? 'border-blue-500! bg-blue-50!' : ''
      }`}
    >
      <div className="relative h-[60vh] md:h-[80vh]">
        {/* Its title, centred on the top row — the row the viewer leaves clear above the page
            (see PdfViewer's top padding). */}
        <PanelTitle
          // Backed like the controls either side of it: the pages scroll up under this row.
          className="pointer-events-none absolute left-1/2 top-3 z-10 h-8 -translate-x-1/2 rounded-lg bg-slate-50/90 px-3 backdrop-blur"
        >
          {t('notice.cat.group.manual')}
        </PanelTitle>
        <PdfViewer key={docId} file={file} docId={docId} onNumPages={onNumPages} partBoxes={partBoxes} />
      </div>
      {/* WHAT THE MANUAL SAYS, UNDER THE MANUAL, in its box: the product's fields are read
          off these pages, and a box of their own beside this one was a second frame around
          the same source. */}
      <div className="flex flex-col items-center gap-2 px-4 pb-5 pt-6 empty:hidden">
        <NoticeInfoTable docId={docId} file={file} />
      </div>
    </div>
  );
}
